import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    messageContainer: {
        flex: 1,
        maxWidth: "100%",
    },
    errorTitle: {
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.secondary.main,
        marginBottom: theme.spacing(1),
    },
    errorMessage: {
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(1),
    },
    removeButtonContainer: {
        display: "flex",
        flex: 1,
        maxWidth: "100%",
        justifyContent: "flex-end",
        marginTop: theme.spacing(1),
        [theme.breakpoints.down("md")]: {
            marginTop: theme.spacing(2),
            justifyContent: "center",
            marginLeft: theme.spacing(2),
        },
    },
}));
